module.exports = __webpack_public_path__ + "img/case5-1.2a39fb4f.png";